import { Ref, RefString } from "@tblabs/truffle";
import { DeviceConfig } from "../../Models/DeviceConfig";
import { DeviceSettingsForAdmin } from "../../Services/DeviceSettingsForAdmin";


export class SettingsEdit
{
    public halt = new Ref<boolean>(this.config?.halt || false);
    public picturePresetName = new Ref<string>(this.config?.picture?.name || "");
    public pictureWidth = new Ref<number>(this.config?.picture?.width || 0);
    public pictureHeight = new Ref<number>(this.config?.picture?.height || 0);
    public pictureCompression = new Ref<number>(this.config?.picture?.compression || 0);
    public pictureVFlip = new Ref<number>(this.config?.picture?.vFlip || 0);
    public pictureHFlip = new Ref<number>(this.config?.picture?.hFlip || 0);
    public pictureBrightness = new Ref<number>(this.config?.picture?.brightness || 0);
    public pictureContrast = new Ref<number>(this.config?.picture?.contrast || 0);
    public pictureSharpness = new Ref<number>(this.config?.picture?.sharpness || 0);
    public pictureRotation = new Ref<number>(this.config?.picture?.rotation || 0);
    public recordPictures = new Ref<boolean>(this.config?.recorder?.enabled || false);
    public recorderStorageDir = new Ref<string>(this.config?.recorder?.storageDir || "");
    public recorderFreeSpaceLimit = new Ref<number>(this.config?.recorder?.freeSpaceLimit || 1000);
    public maxIdleTime = new Ref<number>(this.config?.maxIdleTime || 0);
    public minPictureSize = new Ref<number>(this.config?.minPictureSize || 0);
    public delayBetweenPictures = new Ref<number>(this.config?.delayBetweenPictures || 0);
    public serversPool = new RefString(this.config?.serversPool?.join("\n") || "");
    public vibrationEnabled = new Ref<boolean>(this.config?.io?.vibrationEnabled || false);
    public touchToVibrationLoopbackEnabled = new Ref<boolean>(this.config?.io?.touchToVibrationLoopbackEnabled || false);
    public startupVibrationEnabled = new Ref<boolean>(this.config?.io?.startupVibrationEnabled || false);
    public connectionVibrationEnabled = new Ref<boolean>(this.config?.io?.connectionVibrationEnabled || false);
    public touchToVibrationLoopbackDuration = new Ref<number>(this.config?.io?.touchToVibrationLoopbackDuration || 250);
    public startupVibrationDuration = new Ref<number>(this.config?.io?.startupVibrationDuration || 3000);
    public inputThrottleTime = new Ref<number>(this.config?.io?.inputsThrottleTime || 50);
    public malfunctionDetectorSamples = new Ref<number>(this.config?.io?.malfunctionDetectorSamples || 100);
    public malfunctionDetectorThreshold = new Ref<number>(this.config?.io?.malfunctionDetectorThreshold || 1000);

    public get HasRecorder(): boolean
    {
        return this.config?.recorder !== undefined;
    }

    constructor(private config: DeviceConfig) { }

    public get Settings(): DeviceSettingsForAdmin
    {
        const serversPoolArray = this.serversPool.value.split("\n").map(x => x.trim()).filter(x => x != "");

        const settings: DeviceSettingsForAdmin = {
            Halt: this.halt.value,
            VibrationEnabled: this.vibrationEnabled.value,
            TouchToVibrationLoopbackEnabled: this.touchToVibrationLoopbackEnabled.value,
            StartupVibrationEnabled: this.startupVibrationEnabled.value,
            ConnectionVibrationEnabled: this.connectionVibrationEnabled.value,
            RecorderEnabled: this.recordPictures.value,
            RecorderStorageDir: this.recorderStorageDir.value,
            RecorderFreeSpaceLimit: this.recorderFreeSpaceLimit.value,
            ServersPool: serversPoolArray,
            MaxIdleTime: this.maxIdleTime.value,
            MinPictureSize: this.minPictureSize.value,
            DelayBetweenPictures: this.delayBetweenPictures.value,
            PicturePresetName: this.picturePresetName.value,
            PictureWidth: this.pictureWidth.value,
            PictureHeight: this.pictureHeight.value,
            PictureCompression: this.pictureCompression.value,
            PictureVFlip: this.pictureVFlip.value,
            PictureHFlip: this.pictureHFlip.value,
            PictureBrightness: this.pictureBrightness.value,
            PictureContrast: this.pictureContrast.value,
            PictureSharpness: this.pictureSharpness.value,
            PictureRotation: this.pictureRotation.value,
            InputsThrottleTime: this.inputThrottleTime.value,
            StartupVibrationDuration: this.startupVibrationDuration.value,
            TouchToVibrationLoopbackDuration: this.touchToVibrationLoopbackDuration.value,
            MalfunctionDetectorSamples: this.malfunctionDetectorSamples.value,
            MalfunctionDetectorThreshold: this.malfunctionDetectorThreshold.value,
        };

        return settings;
    }
}
